import LiveBadge from "../components/LiveBadge.jsx"
import BackButton from "../components/BackButton";
import DataTransmissionTable from "../components/DataTransmissionTable";
import DataTransmissionLegend from "../components/DataTransmissionLegend";
import { useState, useEffect } from "react";
import api from "../api/DataTransmissionReq";
import UnassignedDevicesTable from "../components/UnassignedDevicesTable";

const DataTransmission = () => {
    const [data, setData] = useState([]);
    const [unassignedDevices, setUnassignedDevices] = useState([]);
    const basemin = 30;
    useEffect(() => {   
        const getAllDataTransmission = async () => {
            try {
                const [response, devicesResponse] = await Promise.all([
                    api.get('all', {withCredentials: true}),
                    api.get('unassigned-devices', {withCredentials: true})
                ]);
                if (response.data.success) {
                    const tempData = response.data.payload.map((record) => {
                        return {
                            flowMeterName: `${record.flow_meter.location_id.place} ${record.flow_meter.location_id.thoroughfare} ${record.flow_meter.location_id.type_line}`,
                            last_availability: record.last_availability 
                        }
                    })
                    setData(tempData);
                } else {
                    setData([]);
                }

                if (devicesResponse.data.success) {
                    setUnassignedDevices(devicesResponse.data.payload);
                } else {
                    setUnassignedDevices([]);
                }
            } catch (err) {
                console.log(err.response);
            }
        }

        getAllDataTransmission()
        const interval = setInterval(() => {
            getAllDataTransmission()
        }, 60000);
        
        return () => clearInterval(interval);
    }, [])

    return (
        <div className="manage-calculations-new-container">
            <div className="live-badge-container"> 
                <LiveBadge />
                &nbsp;
                &nbsp;
                <h2>Data Transmission</h2>
            </div>
            
            <br />
            <UnassignedDevicesTable devices={unassignedDevices} />
            <DataTransmissionTable
                data={data}
                min={basemin}
            />
            <DataTransmissionLegend 
                min={basemin}
            />
            <BackButton navigateTo='/menu'/> 
        </div>
    );
};

export default DataTransmission;
